import { NumberFormat } from '../types';

export const convertNumberFormat = (value: number, format: NumberFormat): string => {
  switch (format) {
    case NumberFormat.COMMA_PERIOD:
      return value.toLocaleString('en-US');
    case NumberFormat.PERIOD_COMMA:
      return value.toLocaleString('de-DE');
    default:
      return value.toString();
  }
};

export const formatFloat = (number: number, maximumFractionDigits: number) => {
  if (isNaN(number) || !isFinite(number)) {
    return number;
  }
  return parseFloat(number.toLocaleString('en-US', { maximumFractionDigits, useGrouping: false }));
};

export const getConfidencePercentage = (confidenceScore: number | null | undefined) => {
  if (typeof confidenceScore !== 'number' || !Number.isFinite(confidenceScore)) {
    return 0;
  }

  return Math.round(confidenceScore * 100);
};

export const formatConfidencePercentage = (confidenceScore: number | null | undefined) =>
  `${getConfidencePercentage(confidenceScore)}%`;
